import { Route, Routes } from "react-router-dom";
import { DRINK__ROUTES, KITCHEN_ROUTES, FILTER_ROUTES } from "./routes/ROUTES";
import MainPage from "./screens/MainPage";
import Markup from "./components/Markup/Markup";
import ProductScreen from "./components/Markup/ProductScreen";
import { Input } from "./components/Header/Input";
import PageNotFound from "./components/PageNotFound/PageNotFound";

const routes = [...KITCHEN_ROUTES, ...DRINK__ROUTES];

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />

      {routes.map(({ types, route }) => (
        <Route key={route}>
          <Route
            key={route}
            path={route}
            element={<Markup path={route} type={types} />}
          />
          <Route
            key={route}
            path={`${route}/:id`}
            element={<ProductScreen type={types} />}
          />
        </Route>
      ))}

      <Route
        path={FILTER_ROUTES[0].route}
        element={
          <Input type={FILTER_ROUTES[0].types} path={FILTER_ROUTES[0].route} />
        }
      />

      <Route
        path={`${FILTER_ROUTES[0].route}/:id`}
        element={<ProductScreen type={FILTER_ROUTES[0].types} />}
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
